import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bar-chart-horizontal-line",
  "use": "icon-bar-chart-horizontal-line-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-bar-chart-horizontal-line\">\n    <g>\n        <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n        <path d=\"M12 3v2H3V3h9zm4 16v2H3v-2h13zm6-8v2H3v-2h19z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol